import React from "react"; 
import { Link } from "react-router-dom";    
import AppUsersListContent from "../../../components/Dashboard/AppUsersListContent";

const AppUsersList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5> Users</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>App Users</li>
          <li>App Users List</li>
        </ul>
      </div> */}

      <AppUsersListContent />
    </>
  );
};

export default AppUsersList;
